import React from 'react';
import { useIntl } from 'react-intl';

import { translations } from '@/locale';
import { getOpenFlights } from '@/services/api/reports';

import useLoad from '@flyblack/common/hooks/useLoad';

import Loading from '@flyblack/common/components/Loading';
import LargeDataDetail from '@flyblack/common/components/LargeDataDetail';
import DetailCard from '@flyblack/common/components/DetailCard';

const ActiveDealsCard = () => {
  const intl = useIntl();

  const { value: openFlightsReport, loading, error } = useLoad({
    load: getOpenFlights
  });

  return (
    <DetailCard>
      {loading ? (
        <Loading visible={loading} className="py-9" center>
          <Loading.Indicator size={40} borderWidth={2} />
        </Loading>
      ) : (
        <LargeDataDetail
          title={intl.formatMessage({ id: translations.pages.jetDeals.reports.activeDeals })}
          data={
            error
              ? intl.formatMessage({ id: translations.pages.jetDeals.reports.errorValue })
              : openFlightsReport.vendorEmptyLegs
          }
        />
      )}
    </DetailCard>
  );
};

export default ActiveDealsCard;
